// import { login, logout, getInfo, getUserResourceTree } from "@/api/user";
// import { getToken, setToken, removeToken } from "@/utils/auth";
import { login, logout, getCurrentUserInfo, getResourceTree } from "@/api/user";
import { getLoginUrl } from "@/utils/config";
import Cookies from "js-cookie";

const getDefaultState = () => {
  return localStorage.getItem('state') ? JSON.parse(localStorage.getItem('state')).user:{
    name: "",
    avatar: "",
    userInfo: {},
    permissionRoutes: [], // 路由菜单
    menuAllList: [],
    menuRouteList: []
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_USERINFO: (state, data) => {
    state.userInfo = data;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_MENU_lIST: (state, menuAllList) => {
    state.menuAllList = menuAllList;
  },
  SET_MENU_ROUTE: (state, menuRouteList) => {
    state.menuRouteList = menuRouteList;
  }
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { email, password } = userInfo;
    return new Promise((resolve, reject) => {
      login({ email: email.trim(), password: password })
      .then((res) => {
          commit("SET_NAME", res.data.nickName);
          commit("SET_USERINFO", res.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout({
        targetUrl: location.origin
      }).then((res) => {
        // removeToken();
        localStorage.removeItem('state')
        localStorage.removeItem('viewCanvas')
        commit("RESET_STATE");
        Cookies.remove('TGC')
        window.location.href = res.data;

        // let href = location.href
        // if(href.indexOf('nopage') > -1) {
        //   href = location.origin 
        // }
        // window.location.href = `${getLoginUrl()}?target_url=${encodeURI(href)}`;
        resolve();
      });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      // removeToken(); // must remove  token  first
      // commit("RESET_STATE");
      resolve();
    });
  },
  // 个人信息
  getCurrentUserInfo({ dispatch, commit }) {
    getCurrentUserInfo().then((res) => {
      gtag('set', 'userId', res.data.userName);
      gtag('set', 'user_properties', { user_name: res.data.userName, 'user_id': res.data.userName });
      gtag('send', 'event', 'authentication', 'user-id available');
      commit('SET_NAME', res.data.userName)
      commit('SET_USERINFO', res.data)
    })
  },
  /**
 * @description: 获取菜单（路由、权限） 钱包上线了，还需要继续优化
 * @param {*} dispatch
 * @param {*} commit
 * @return {*}
 */
  async getMenuTree({ dispatch, commit }) {
    try {
      const treeResponse = await getResourceTree()
      if (treeResponse.data) {
        commit("SET_MENU_lIST", treeResponse.data);
        let list = []
        let fun = (arr) => {
          list = list.concat(arr.map(v => v.routeName))
          for (let i = 0; i < arr.length; i++) {
            const element = arr[i];
            if(element.resources&&element.resources.length) {
             fun(element.resources) 
            }
          }
        }
        fun(treeResponse.data)
        commit("SET_MENU_ROUTE", list);
      }
    } catch (error) {
      console.warn("GET_TREE", error);
    }
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
